export default __webpack_public_path__ + "static/media/Maithili_am_2.81344605.mp3";